import { memo } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import NamedEntityRecognitionTaskComponent from './NamedEntityRecognitionTaskComponent';

function NamedEntityRecognitionPinnedViewComponent(props: StepViewComponentProps) {
  return <NamedEntityRecognitionTaskComponent {...props} isPinnable isPinnedView={false} />;
}

export default memo(NamedEntityRecognitionPinnedViewComponent);
